export default __webpack_public_path__ + "static/media/hover.7ea9ae67.svg";